import moment from "moment";


const getWeeksRange = (currentWeek: string, weeksSize: number) => {

  const range: number[] = []

  const year = Number(currentWeek.substring(0, 4))
  const weekNumber = Number(currentWeek.substring(4, 6))

  const week = moment().isoWeekYear(year).isoWeek(weekNumber)

  for(let i = 0; i < weeksSize; i++) {

    range.push(Number(week.format('YYYYWW')))

    week.add(1, 'w')
  }

  return range
}
/**
 * Get the week navigator for lookahead
 * @param projectStart The start date of the project format utc
 * @param projectEnd The end date of the project format utc
 * @param week The current week of the project format YYYYWW
 * @returns The week navigator in an object with previous, next and current week
 */


interface INavigator {
  projectStart: string,
  projectEnd: string,
  weeksSize: number,
  week?: string
}

type TNavigatorResult = {
  prev: string,
  next: string,
  week: number,
  range: number[],
  start: number,
  startDay: string,
  end: number,
  endDay: string,
}

export const getWeekNavigator = (options: INavigator): TNavigatorResult => {

  const { projectStart, projectEnd, weeksSize, week } = options

  const start = moment(projectStart);
  const end = moment(projectEnd);
  const last = end.clone().subtract(weeksSize, 'week')

  let currentWeek = week ? moment(week, 'YYYYWW') : moment();
  let isLastWeek = false

  if (currentWeek.isBefore(start, 'week')) {

    currentWeek = start.clone()
  } else if (currentWeek.isAfter(last, 'week')) {

    currentWeek = last.clone()
    isLastWeek = true
  }

  const isFirstWeek = currentWeek.isSame(start, 'week')

  const prevWeek = isFirstWeek ? undefined : currentWeek.clone().subtract(1, 'week').format('YYYYWW')
  const nextWeek = isLastWeek ? undefined : currentWeek.clone().add(1, 'week').format('YYYYWW')

  const range = getWeeksRange(currentWeek.format('YYYYWW'), weeksSize)
  const rangeFirstDay = moment(range[0].toString(), 'YYYYWW').startOf('W')
  const rangeLastDay = moment(range[range.length - 1].toString(), 'YYYYWW').endOf('W')

  const rangeStartDay = rangeFirstDay.isBefore(start) ? start : rangeFirstDay
  const rangeEndDay = rangeLastDay.isAfter(end) ? end : rangeLastDay

  return {
    prev: prevWeek || '',
    next: nextWeek || '',
    week: Number(currentWeek.format('YYYYWW')),
    range: getWeeksRange(currentWeek.format('YYYYWW'), weeksSize),
    start: Number(start.format('YYYYWW')),
    startDay: rangeStartDay.format('YYYY-MM-DD'),
    end: Number(end.format('YYYYWW')),
    endDay: rangeEndDay.format('YYYY-MM-DD'),
  }
}
